import { autocomplete, getAlgoliaResults, AutocompleteComponents } from '@algolia/autocomplete-js';
import {
  AutocompleteInsightsApi,
  createAlgoliaInsightsPlugin,
} from '@algolia/autocomplete-plugin-algolia-insights';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import algoliasearch from 'algoliasearch/lite';
import insightsClient from 'search-insights';
import { ProductHit } from './ProductHit';

const appId = algolia.application_id;
const apiKey = algolia.search_api_key;
const searchClient = algoliasearch(appId, apiKey);

const query_suggestion_index = algolia.autocomplete.sources[0].index_name
// @ts-expect-error type error in search-insights
insightsClient('init', { appId, apiKey: algolia_search_only_api_key });
if(typeof algoliaUserToken != 'undefined'){
  insightsClient('setUserToken', algoliaUserToken);
}

const algoliaInsightsPlugin = createAlgoliaInsightsPlugin(
  {
    insightsClient,
    onItemsChange({ insights, insightsEvents }) {

      const events = insightsEvents.map((insightsEvent) => ({
        ...insightsEvent,
        eventName: insightsEvent.index == query_suggestion_index ? 'Suggestion Viewed from Autocomplete' : 'Product Viewed from Autocomplete',
        useCookie: isUserLoggedIn ? false : true,
      }));
      
      insights.viewedObjectIDs(...events);
    },
    onSelect({ insights, insightsEvents }) {
      const events = insightsEvents.map((insightsEvent) => {
        switch (insightsEvent.index) {
          case query_suggestion_index:
            return {
              ...insightsEvent,
              eventName: 'Suggestion Click',
              userToken: typeof algoliaUserToken != 'undefined' ? algoliaUserToken : ''
            }
        }
        return {
          ...insightsEvent,
          eventName: 'Product Click',
          userToken: typeof algoliaUserToken != 'undefined' ? algoliaUserToken : ''
        }
      })
      insights.clickedObjectIDsAfterSearch(...events)
    },
  });

let lang_prefix = (typeof icl_vars != "undefined" && icl_vars.current_language == "ar") ? '/ar' : '';

if(typeof forceLangOnUrl != "undefined" && forceLangOnUrl == "yes"){
   lang_prefix = (typeof icl_vars != "undefined" && icl_vars.current_language == "ar") ? '/ar' : '/en';
}

const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
  key: 'query-suggestions-historyv2',
  limit: 5,
  transformSource({ source, state }) {

    if (state.query) return null;
    const rr = {
      ...source,
      sourceId: 'recents',
      onSelect(props) {
        // let recent_searches = localStorage.getItem(key)
        // recent_searches = JSON.parse(recent_searches)
        // recent_searches = recent_searches.filter(r => r.id != props.item.id)
        // recent_searches.unshift({ id: props.item.id, label: props.item.id })
        // localStorage.setItem(key, JSON.stringify(recent_searches))
         let currentRecents = props.state.collections.filter((c) => c.source.sourceId == "recents")
       
        //if (currentRecents.length > 0) {
        // const currentRecentItems = currentRecents[0].items.map(i => i.id).join("|")
        if(typeof(enable_ga4) !== 'undefined' && enable_ga4){

          let search_term = $('.search-form .aa-Input').val(); 
          let selected_search_term= props.item.id; 
          let selected_search_sku= undefined;
          let search_action= 'Recent Search';
          let search_category= undefined;
          let search_results_number= currentRecents && currentRecents.length > 0 && typeof(currentRecents[0]) !== 'undefined' && typeof(currentRecents[0].items) !== 'undefined' ? currentRecents[0].items.length: undefined;
          let search_popular_results_number = undefined
          console.log('RR');
          //TODO enable_ga4
          dataLayerProductClick(search_term, selected_search_term, selected_search_sku, search_action, search_category, search_results_number,search_popular_results_number)
        
        } else {
          dataLayer.push({
            event: "algolia_suggest",
            eventCategory: "Auto Suggestion",
            eventAction: "Recent Search Click",
            eventLabel: props.item.id
          });
        }
        let itemId = props.item.id 
       // recentSearchesPlugin.data?.addItem({ id: itemId, label: itemId })
        // }
      },
      getItemUrl({ item }) {
        let itemId = encodeURIComponent(item.id); 
        let link = `${lang_prefix}/?q=${itemId}`
        // if (item.category) {
        //   link += `&dFR[taxonomies.product_cat][0]=${item.category}`
        // }
        link += `&post_type=product`
        return link
      },
      templates: {
        ...source.templates,
        item(params) {

          const { item, html } = params;
          let itemId = encodeURIComponent(item.id);
          let link = `${lang_prefix}/?q=${itemId}`
          // if (item.category) {
          //   link += `&dFR[taxonomies.product_cat][0]=${item.category}`
          // }
          link += `&post_type=product`
          return html`<a
            class="aa-ItemLink"
            href="${link}"
          >
            ${source.templates.item(params).props.children}
          </a>`;
        },
      },
    };

    return rr
  },
});

const querySuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: query_suggestion_index,
  getSearchParams: () => ({ clickAnalytics: true }),
  categoriesPerItem: 0,
  transformSource({ source, state }) {

   // console.log(source);
    if (!state.query) return null;

    const rr = {
      ...source,
      sourceId: 'suggestions',
      onSelect(props) {

        let currentSuggestions = props.state.collections.filter((c) => c.source.sourceId == "suggestions")
        // if (currentSuggestions.length > 0) {
        // const currentSuggestionItems = currentSuggestions[0].items.map(i => i.query).join("|")
        if(typeof(enable_ga4) !== 'undefined' && enable_ga4){
       
          let search_term= state.query; 
          let selected_search_term= props.item.query;
          let search_action= 'Suggested Search';
          let search_category= props.item && props.item.__autocomplete_qsCategory;
          let search_results_number= currentSuggestions[0].items.length; 
          let selected_search_sku = undefined; 
          let search_popular_results_number =  $(".aa-Source[data-autocomplete-source-id='products'] li").length;
          
          dataLayerProductClick(search_term, selected_search_term, selected_search_sku, search_action, search_category, search_results_number,search_popular_results_number)
        
        } else {

        dataLayer.push({
            event: "algolia_suggest",
            eventCategory: "Auto Suggestion",
            eventAction: "Query Suggestion Click",
            eventLabel: props.item.query
          });
        }
        

          



        //}

        //recentSearchesPlugin.data?.addItem({ id: props.item.query, label: props.item.query })
      },
      getItemUrl({ item }) {

        let link = `${lang_prefix}/?q=${item.query}`
        // if (item.__autocomplete_qsCategory) {
        //   link += `&dFR[taxonomies.product_cat][0]=${item.__autocomplete_qsCategory}`
        // }
        link += `&post_type=product`
        return link
      },
      templates: {
        ...source.templates,
        item(params) {

          const { item, html } = params;

          if (!item.query) return null;

          let link = `${lang_prefix}/?q=${item.query}`
          if (item.__autocomplete_qsCategory) {
            link += `&dFR[taxonomies.product_cat][0]=${item.__autocomplete_qsCategory}`
          }
          link += `&post_type=product`
          return html`<a
            class="aa-ItemLink"
            href="${link}"
          >
            ${source.templates.item(params).props.children}
          </a>`;
        },
      },
    };

    return rr
  },
});

const url = new URL(location.href);
const searchParams = url.searchParams;
const query = searchParams.get('q') || ''

function debouncePromise(fn, time) {
  let timerId = undefined;

  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}
const debounced = debouncePromise((items) => Promise.resolve(items), 300);

function sendHistoryToGA() {
  if (window.algolia_history_sent_to_ga) return
  window.algolia_history_sent_to_ga = true
  if(typeof(enable_ga4) !== 'undefined' && enable_ga4){
    //TODO enable_ga4  
  } else {
    dataLayer.push({
      event: "algolia_suggest",
      eventCategory: "Auto Suggestion",
      eventAction: "Viewed",
      eventLabel: "Recent Search"
    });
  }
}

$(document).ready(function () {


  $(".search-form").on("keypress", ".aa-Input", function (event) {
    var regex = new RegExp("^[&+\u0621-\u064Aa-zA-Z0-9\u0660-\u0669 .\b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key) && !(event.key === 'Enter' || event.keyCode === 13)) {
      event.preventDefault();
      return false;
    }
  })

  $(".search-form").on("input", ".aa-Input", function (event) {
    if(window.search_input_manually_set){
      window.search_input_manually_set = false
      return
    }
    var regex = new RegExp("^[&+\u0621-\u064Aa-zA-Z0-9\u0660-\u0669 .\b]+$");
    var inp = event.target
    var val = inp.value

    if (!regex.test(val)) {``
      ac.setQuery("");
      ac.setIsOpen(false)
    }
    inp.value = val.replace(/[^&+\u0621-\u064AA-Za-z0-9\u0660-\u0669 .]+/g, "")
    window.search_input_manually_set = true
    var event = new Event('input');
    $(".aa-Input")[0].dispatchEvent(event)
    $(".aa-Input").trigger("input")

  })

  $(".search-form").on("blur", ".aa-Input", function (event) {
    if($(".aa-Input").val()){
      if(typeof(enable_ga4) !== 'undefined' && enable_ga4){
        //TODO enable_ga4
      } else {
        dataLayer.push({
          event: "sendEvent",
          eventCategory: "Exp Desktop Auto Suggestion",
          eventAction: "useEnabled",
          eventLabel: "6lOghy1sTG2Dxy7E0vwJ_w"
        });
      }
    }
  })

  var algoliaFilters = defaultAlgoliaFilter;
  if (algolia.instock) {
    algoliaFilters = algoliaFilters + " AND in_stock:1 ";
  }
  if (typeof erp !== "undefined" && erp == 2) {
    algoliaFilters = algoliaFilters + " AND taxonomies.erp_ver:" + erp;
  }

  window.ac = autocomplete<ProductHit>({
    container: '.search-form',
    panelContainer: '.search-form',
    //placeholder: $.validator.messages.search_sharafdg,
    ...(typeof typewriterData == 'undefined' || !typewriterData.dynamicWords ? {
      placeholder: $.validator.messages.search_sharafdg
    }:{}),
    detachedMediaQuery: 'none',
    stallThreshold: 300,
    openOnFocus: true,
    initialState: {
      query
    },
    onStateChange: function (props) {
      if (!props.state.query && props.state.isOpen && props.state.status == 'idle' && props.prevState.status != 'idle') {
        sendHistoryToGA()
      } else if (!window.first_search_box_click && !props.state.query && props.state.isOpen) {
        sendHistoryToGA()
        window.first_search_box_click = true
      }
      if (props.state.isOpen) {
        $(".navbar-header,body").addClass("search-open")
      } else {
        $(".navbar-header,body").removeClass("search-open")
      }
      if (props.prevState.collections.length != 0 && props.state.collections.length == 0) {
        $(document).trigger("ac_empty")
      }
      setTimeout(() => {
        if ($(".aa-SourceNoResults").length > 0) {
          $(".navbar-header").addClass("empty-search")
        } else {
          $(".navbar-header").removeClass("empty-search")
        }
      }, 1)
    },
    plugins:  [recentSearchesPlugin, querySuggestionsPlugin, algoliaInsightsPlugin],
    onSubmit({ state }) {
      var url = `${lang_prefix}/?q=${state.query}&post_type=product`
      var query = state.query
      if (!query) return false;
      sharafValidation.searchFormSubmitHandler(null, url, query)
    },
    onReset({ state }) {
      if(typeof(enable_ga4) !== 'undefined' && enable_ga4 && typeof SharafDGGA4 !== 'undefined'){
        var query = state.query
        dataLayer.push({
          event: "clear_search",
          client_platform: SharafDGGA4.getClientPlatform(),
          cleared_value: query,
          eventCallback: function () { //For datalayer flushing..
            dataLayer.push({
              cleared_value: undefined, 
            });
          }
        });
      }  
    },
    getSources({ query, state }) {
      if (!query) {
        return [];
      }
      if(typeof sdg_store_mode_enabled !='undefined' && sharafSearch.getCookie("sdg_store_page")) {
        return [];
      }
      return debounced([
        {
          sourceId: 'products',
          onSelect: function (props) {
            if(typeof icl_vars != "undefined" && icl_vars.current_language == "ar"){
                location.href = props.item.permalink_ar  
              } else {
                location.href = props.item.permalink;
              }
          },
          getItems() {
            return getAlgoliaResults<ProductHit>({
              searchClient,
              queries: [
                {
                  indexName: algolia.indices.posts_product.name,
                  query,
                  params: {
                    hitsPerPage: 5,
                    filters: algoliaFilters,
                    attributesToRetrieve:
                      "permalink,permalink_ar,post_title,post_id,post_title_ar,main_sku,taxonomies.taxonomies_hierarchical.product_cat,taxonomies_ar.product_cat,taxonomies.product_brand,taxonomies_ar.product_brand,discount,discount_val,images,price,promotion_offer_json,regular_price,sale_price,in_stock,rating_reviews",
                    getRankingInfo: 1,
                    attributesToHighlight: "post_title,post_title_ar",
                    maxValuesPerFacet: 5,
                    clickAnalytics: true
                  },
                },
              ],
            });
          },
          templates: {
            item(props) {
              const { item, components } = props
              return (
                <ProductItem
                  hit={item}
                  components={components}
                  insights={state.context.algoliaInsightsPlugin.insights}
                />
              );
            },
            noResults() {
              return ""
            },
          },
        },
      ])
    },
  });

  $(".aa-Form.temp").remove()

  $(document).on('pjax:start', function () {
    ac.setQuery("")
  })

  $(document).on('ac_empty', function () {
    setTimeout(() => {
      ac.setIsOpen(false)
    }, 0)

  })
})

type ProductItemProps = {
  hit: ProductHit;
  insights: AutocompleteInsightsApi;
  components: AutocompleteComponents;
};

function ProductItem({ hit, insights, components }: ProductItemProps) {
  var processed_hit = Object.assign({}, hit);
  processed_hit = sharafSearch.process_hit(processed_hit)
  var isSAR = sdgCurrency.indexOf("SAR") !== -1 || sdgCurrency.indexOf("ريال") !== -1

  return (
    <a href={processed_hit.permalink} className="aa-Product" onClick={e => {
      if(typeof(enable_ga4) !== 'undefined' && enable_ga4){
        let search_term = $('.search-form .aa-Input').val(); 
        let selected_search_term= processed_hit.post_title; 
        let selected_search_sku= processed_hit.main_sku;
        let search_action= 'Product Search';
        let search_category= undefined;
        let search_results_number= $(".aa-Source[data-autocomplete-source-id='suggestions'] li").length;
        let search_popular_results_number = $(".aa-Source[data-autocomplete-source-id='products'] li").length;
        dataLayerProductClick(search_term, selected_search_term, selected_search_sku, search_action, search_category, search_results_number,search_popular_results_number);
      } else {
        dataLayer.push({
          event: "algolia_suggest",
          eventCategory: "Auto Suggestion",
          eventAction: "Product Click",// what is viewed if recent search item only
          eventLabel: processed_hit.main_sku + "-" + processed_hit.post_title
        });
    }
      //insights.clickedObjectIDsAfterSearch(click_event)
    }}>
      <div className="aa-ItemContent">
        <div className="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
          <img src={processed_hit.images} alt={processed_hit.name} width="40" height="40" />
        </div>
        <div className="aa-ItemContentBody">
          <div className="aa-ItemContentTitle">
          {current_locale == 'ar' && processed_hit.post_title_ar}
          {current_locale != 'ar' && processed_hit.post_title}
          
          </div>
          <div className="aa-ItemPrice" >
            {processed_hit.regular_price && (rtl && <span className="was-price">{processed_hit.regular_price} {isSAR && <svg class="currency_symbol"><use xlinkHref="#riyal_symbol"></use></svg>}{!isSAR && sdgCurrency}</span>)}
            {processed_hit.regular_price && (!rtl && <span className="was-price">{isSAR && <svg class="currency_symbol"><use xlinkHref="#riyal_symbol"></use></svg>}{!isSAR && sdgCurrency} {processed_hit.regular_price}</span>)}
            {rtl && <span className="price">{processed_hit.price} {isSAR && <svg class="currency_symbol"><use xlinkHref="#riyal_symbol"></use></svg>}{!isSAR && sdgCurrency} </span>}
            {!rtl && <span className='price'>{isSAR && <svg class="currency_symbol"><use xlinkHref="#riyal_symbol"></use></svg>}{!isSAR && sdgCurrency} {processed_hit.price}  </span>}
          </div>
        </div>
      </div>
    </a>
  );
}


function dataLayerProductClick(search_term, selected_search_term, selected_search_sku, search_action, search_category, search_results_number,search_popular_results_number){
  if(typeof (SharafDGPageMeta) !== 'undefined' && SharafDGPageMeta.setPageLevelMeta){
    SharafDGPageMeta.setPageLevelMeta();
  } 
  var dataLayerObj = {
    event: "search", 
    selected_search_term, 
    search_action,
    search_results_number,
    eventCallback: function () { //For datalayer flushing
      dataLayer.push({
        search_term: undefined,
        selected_search_term: undefined,
        selected_search_sku:undefined, 
        search_action: undefined,
        search_category: undefined,
        search_results_number: undefined, 
      });
    }
  }
  if(search_term){
    dataLayerObj.search_term = search_term
  }
  if(selected_search_sku){
    dataLayerObj.selected_search_sku = selected_search_sku;
  }
  if(search_category){
    dataLayerObj.search_category = search_category;
  }
  if(search_popular_results_number){
    dataLayerObj.search_popular_results_number = search_popular_results_number;
  }
  dataLayer.push(dataLayerObj);
}